import React, { useEffect, useState } from 'react';
import Paragraph from '../../Components/Paragraph';
import Heading from '../../Components/Heading';
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import faqopen from'../../../assets/faqopen.png';
import Aos from 'aos';

const Wrapper = styled(Box)`
  padding: 100px 0px 180px 0px;
`;

const FAQContainer = styled(Box)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const StyledAccordion = styled(Accordion)`
  background: #080411;
  border: 1px solid #222222;
  border-radius: 20px !important;
  margin-bottom: 16px;
  box-shadow: none;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  
  &:before {
    display: none;
  }
  
  &.Mui-expanded {
    margin: 0 0 16px 0;
    background-image: url(${faqopen});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  &.Mui-expanded::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(8, 4, 17, 0.85);
    z-index: 0;
  }
  
  & > * {
    position: relative;
    z-index: 1;
  }
`;
const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 24px 32px;
  min-height: 80px !important;
  
  &.Mui-expanded {
    min-height: 80px !important;
  }
  
  .MuiAccordionSummary-content {
    margin: 0 !important;
    
    &.Mui-expanded {
      margin: 0 !important;
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 32px;
  padding-top: 24px;
`;

const QuestionText = styled(Paragraph)`
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  text-align: left;
`;

const AnswerText = styled(Paragraph)`
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  text-align: left;
`;

const PlusIcon = styled(AddIcon)`
  color: #a860ff;
  font-size: 25px;
`;

const MinusIcon = styled(RemoveIcon)`
  color: #a860ff;
  font-size: 25px;
`;

const ExpandIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  .MuiAccordionSummary-expandIconWrapper.Mui-expanded & {
    background: #180B2B;
  }
`;

const FAQS = () => {
     useEffect(() => {
          
              Aos.init({
                duration: 1200,
                offset: 100,
                once: true, 
                easing: 'ease-out-cubic',
                mirror: false,
              });
            }, []);
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const faqData = [
    {
      id: 'faq1',
      question: 'What is Shadow Node?',
      answer: 'Shadow Node is a privacy infrastructure ecosystem built for the multichain internet. Powered by SVPN, the ecosystem combines encrypted communication, private access, anonymous browsing, and censorship resistant networking into one unified infrastructure layer.'
    },
    {
         id: 'faq2',
      question: 'What is SVPN?',
      answer: 'SVPN is the utility layer powering the Shadow Node ecosystem. It connects infrastructure participation, ecosystem services, network access, and future product integrations across the growing privacy stack.'
    },
    {
      id: 'faq3',
      question: 'Is Shadow Node only a VPN?',
      answer: 'No. While ShadowNode VPN remains a core part of the ecosystem, Shadow Node has expanded into a broader privacy infrastructure platform that includes communication, browsing, and transactional privacy layers designed for the multichain internet.'
    },
    {
      id: 'faq4',
      question: 'What is ShadowNode VPN?',
      answer: 'ShadowNode VPN delivers secure, high performance private access through encrypted routing and censorship resistant networking infrastructure. It is designed to provide reliable connectivity, privacy protection, and unrestricted access across supported environments.'
    },
    {
      id: 'faq5',
      question: 'What is ShadowTalk?',
      answer: 'ShadowTalk is the encrypted communication layer of the Shadow Node ecosystem. It is designed for secure messaging across both online and offline environments, including support for offline Bitcoin transfers in restricted network conditions.'
    },
    {
      id: 'faq6',
      question: 'What is ShadowSurf?',
      answer: 'ShadowSurf is the private browsing layer of the ecosystem, focused on secure and protected internet navigation built on Shadow Node infrastructure.'
    }
  ];

  const CustomExpandIcon = ({ isExpanded }) => {
    return (
      <ExpandIconWrapper>
        {isExpanded ? <MinusIcon /> : <PlusIcon />}
      </ExpandIconWrapper>
    );
  };

  return (
    <Wrapper data-aos="fade-up" id='faqs' data-aos-once="false">
      <FAQContainer>
        <Grid container justifyContent={'center'} textAlign={'center'}>
          <Grid item xs={12}>
            <Heading style={{ marginBottom: '20px' }}>
              <span style={{
                background: "linear-gradient(128deg, rgb(255 255 255) 52%, rgb(168, 96, 255)) text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 'bolder',
              }}>
                Got Questions?
              </span>
              <br />
              <span style={{
                background: "linear-gradient(128deg, rgb(255 255 255) 52%, rgb(168, 96, 255)) text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 'bolder',
              }}>
                We've Got Answers
              </span>
            </Heading>
          </Grid>
        </Grid>

        <Grid container justifyContent={'center'} style={{ marginTop: '60px' }}>
          <Grid item xs={12} md={10} lg={10}>
            {faqData.map((faq, index) => (
              <StyledAccordion
                key={faq.id}
                expanded={expanded === faq.id}
                onChange={handleChange(faq.id)}
              >
                <StyledAccordionSummary
                  expandIcon={<CustomExpandIcon isExpanded={expanded === faq.id} />}
                  aria-controls={`${faq.id}-content`}
                  id={`${faq.id}-header`}
                >
                  <Paragraph style={{marginBottom:'0px'}}>
                    {faq.question}
                  </Paragraph>
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                  <Paragraph>
                    {faq.answer}
                  </Paragraph>
                </StyledAccordionDetails>
              </StyledAccordion>
            ))}
          </Grid>
        </Grid>
      </FAQContainer>
    </Wrapper>
  );
}

export default FAQS;